import React from 'react';
//import Menu from '../../components/Menu';
import {MHeaderV2} from '../../../components/MHeader';
import MFooter from '../../../components/MFooter'

function Home () {
  return (
    <div>
    <MHeaderV2/>
        <div style={{height: "450px"}}>
            {/*Conteudo*/}
            <h1>
                Uma página qualquer so para simular o uso do Header
            </h1>
            <p> Uma página qualquer so para simular o uso do Header </p>
            <p> Uma página qualquer so para simular o uso do Header </p>
            <p> Uma página qualquer so para simular o uso do Header </p>
            <p> Uma página qualquer so para simular o uso do Header </p>
            <p> Uma página qualquer so para simular o uso do Header </p>
        </div>

        <MFooter />
        {/*
        */}
    </div>
  );
}

export default Home;
